import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const Propinsi = ({ id }) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [propinsi, setPropinsi] = useState('')

    useEffect(() => {
        const getPropinsi = async () => {
            if (id !== undefined) {
                const response = await masterService.getPropinsiById(id)
                setPropinsi(response.data.uraianPropinsi)
            }
        }
        getPropinsi()
    }, [masterService, id])

    return (
        <>
            {propinsi}
        </>
    )
}

export default Propinsi